import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Check } from 'lucide-react';

export const CarePricing = ({ compact }) => (
  <div className={`rounded-[24px] bg-[#181B30] text-white ${compact ? 'p-6' : 'p-8'}`} data-testid="care-pricing">
    <p className="text-xs font-semibold tracking-wide text-teal-300">STAYMII CARE™ PRICING</p>
    <p className="mt-3 flex items-end gap-2"><span className="text-4xl font-bold" data-testid="care-price">RM199</span><span className="text-slate-400 mb-1">/ month</span></p>
    <p className="mt-1 text-sm text-teal-300 font-semibold" data-testid="care-trial">14-day free trial · setup included</p>
    <ul className="mt-5 space-y-2 text-sm text-slate-300">
      {['Unlimited residents & staff users', 'Admission, PDPA & contract forms with e-signature', 'Monthly invoices, Pay Now links & receipts'].map((t) => (
        <li key={t} className="flex gap-2"><Check className="w-4 h-4 text-teal-300 shrink-0 mt-0.5" />{t}</li>
      ))}
    </ul>
    <Link to="/staymii-care#demo" data-testid="care-start-trial" className="mt-6 inline-flex items-center gap-2 px-5 py-3 rounded-full bg-teal-500 hover:bg-teal-400 text-[#181B30] font-semibold transition-colors">
      Start 14-day free trial <ArrowRight className="w-4 h-4" />
    </Link>
  </div>
);

export const CareCustomers = () => (
  <div className="text-center" data-testid="care-customers">
    <p className="text-xs font-semibold tracking-[0.2em] text-slate-500">TRUSTED BY</p>
    <img src="/og/care_customers.jpg" alt="ATTA Care, MiiCare Home and ATTA Castle Care logos" className="mx-auto mt-4 h-28 sm:h-36 w-auto rounded-xl" />
    <p className="mt-3 text-sm text-slate-600">Atta Care · Mii Care · Atta Castle Care</p>
  </div>
);

export default function CareHomePromo() {
  return (
    <section className="py-14 lg:py-20 bg-[#F7F4EE]" data-testid="home-care-promo">
      <div className="max-w-7xl mx-auto px-5 lg:px-10 grid lg:grid-cols-12 gap-8 items-center">
        <Link to="/staymii-care" className="lg:col-span-7 block" data-testid="home-care-image-link">
          <img src="/og/staymii-care.jpg" alt="StayMii Care — care management made simple" className="w-full rounded-[24px] shadow-lg" />
        </Link>
        <div className="lg:col-span-5"><CarePricing compact /></div>
      </div>
    </section>
  );
}
